import React, { useRef } from 'react';
import resume from '../../assets/files/Md-Saqib.pdf'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import './Header.css';

const Header = () => {
    const headerActive = useRef(null);
    function showActiveHeader(){
        if(this.scrollY >= 85){
            headerActive.current?.classList.add('active')
        }else{
            headerActive.current?.classList.remove('active')
        }
    }
    window.addEventListener('scroll', showActiveHeader);

    function toggleMenuClass(){
        const menu = document.getElementById('menu');
        menu.classList.toggle('active');
    }
  return (
    <>
        <div className='header' ref={headerActive}>
        <h1 className="logo">Ms.</h1>
        <div className='menu' id='menu' onClick={toggleMenuClass}>
            <ul>
                <li><a href="#aboutSection"><span>1.</span> About</a></li>
                <li><a href="#skillSection"><span>2.</span> Skills</a></li>
                <li><a href="#projectSection"><span>3.</span> Projects</a></li>
                <li><a href="#contactSection"><span>4.</span> Contact</a></li>
                <li className='resumeBtn'><a download href={resume}>Resume</a></li>
            </ul>
            <div className="cancel-icon"><FontAwesomeIcon icon={faTimesCircle} size="3x"/></div>
        </div>
        <div className="menu-icon" onClick={toggleMenuClass}>
        <span></span><span></span><span></span><span></span>
        </div>
        </div>
        </>
  );
}

export default Header